// extracted by mini-css-extract-plugin
module.exports = {"general_container":"Print_general_container__3vtgj","item":"Print_item__pUXN3"};